import { ActionBar, WarningIcon, Block, P, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colors.orange2};
`;

export const StyledBlock = styled(Block)`
  margin-top:36px;
 `;

export const StyledP = styled(P)`
  margin-bottom:16px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  ${media.sm`
    text-align: left;
  `}
 `;

export const StyledActionBar = styled(ActionBar)`
  align-items: center;
 `;

export const StyledIconDiv = styled.div`
  margin-right: 0;
  color: ${({ theme }) => theme.colors.teal7};
  margin-bottom: 12px;
  text-align: center;
  ${media.sm`
    margin-bottom: 0;
    margin-right: 12px;
    text-align: left;
  `}
`;

export const StyledAside = styled.aside`
  display: inherit;
  ${media.sm`
    display: flex;
  `}
`;
